import React, { useState } from 'react';

export default function Upload({ userId }) {
  const [msg, setMsg] = useState(null);
  const [ok, setOk] = useState(false);

  if (!userId) return <p>Please sign up first.</p>;

  const upload = async (e) => {
    e.preventDefault();
    setMsg(null); setOk(false);
    const file = e.target.file.files[0];
    if (!file) return;

    const isVcf = file.name.endsWith('.vcf');
    const fd = new FormData();
    fd.append('file', file);
    fd.append('user_id', userId);

    try {
      const res = await fetch(`/api/upload/${isVcf ? 'vcf' : 'csv'}`, { method: 'POST', body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setMsg(`Imported ${data.imported} contacts.`);
      setOk(true);
    } catch (err) {
      setMsg(err.message);
    }
  };

  return (
    <div>
      <h2>Upload Contacts</h2>
      <p style={{ color: '#666', marginBottom: '1rem' }}>Upload a CSV or .vcf file with your contacts.</p>
      {msg && <div className={`msg ${ok ? 'ok' : 'err'}`}>{msg}</div>}
      <form onSubmit={upload}>
        <input type="file" name="file" accept=".csv,.vcf" required />
        <button type="submit" style={{ marginTop: '0.5rem' }}>Upload</button>
      </form>

      <div className="card" style={{marginTop: '2rem', borderTop: '1px solid #eee', paddingTop: '1.5rem'}}>
        <h3>Quick Export Guide</h3>
        <div style={{textAlign: 'left', fontSize: '0.9rem', color: '#666', lineHeight: '1.6'}}>
          <p><strong>📱 iPhone / iOS:</strong><br/>
          Go to <strong>Settings</strong> → <strong>Apple ID</strong> → <strong>iCloud</strong> → <strong>Show All</strong>. Ensure Contacts is ON. 
          Then visit <a href="https://icloud.com" target="_blank" rel="noreferrer">iCloud.com</a> on a computer → <strong>Contacts</strong> → <strong>Gear Icon</strong> → <strong>Export vCard</strong>.</p>
          
          <p><strong>💻 Mac:</strong><br/>
          Open the <strong>Contacts</strong> app → Select all contacts (Cmd+A) → <strong>File</strong> → <strong>Export</strong> → <strong>Export vCard...</strong></p>
          
          <p><strong>💡 Pro Tip:</strong><br/>
          You can also just text me! Try: <em>"Add my uncle Dan, birthday is February 26"</em></p>
        </div>
      </div>
    </div>
  );
}
